'use strict';

import angular from 'angular';
import RecoverRequestController from './recoverRequest.controller';
import RecoverPasswordController from './recoverPassword.controller';

export default angular.module('wftOrderFormApp.recover', [])
  .controller('RecoverRequestController', RecoverRequestController)
  .controller('RecoverPasswordController', RecoverPasswordController)
  .name;



// WEBPACK FOOTER //
// ./client/app/account/recover/index.js